// NaCl box decryption over a visit's shared key (visits.sharedKey, base64).
// Wire format matches the patient/provider apps: base64(nonce ‖ ciphertext),
// payload is JSON. On any failure the raw input is returned so unencrypted /
// foreign messages render as-is instead of crashing.
import { box } from "tweetnacl";

export const decodeBase64 = (base64Str) =>
  Uint8Array.from(atob(base64Str), (c) => c.charCodeAt(0));

export const decrypt = (sharedKey, messageWithNonce) => {
  try {
    const messageWithNonceAsUint8Array = decodeBase64(messageWithNonce);
    const nonce = messageWithNonceAsUint8Array.slice(0, box.nonceLength);
    const message = messageWithNonceAsUint8Array.slice(box.nonceLength);

    const decrypted = box.open.after(message, nonce, sharedKey);
    if (!decrypted) {
      throw new Error("Could not decrypt message");
    }

    return JSON.parse(new TextDecoder().decode(decrypted));
  } catch {
    return messageWithNonce ? messageWithNonce : "";
  }
};
